<template>
  <v-container grid-list-md class="pa-5">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-card flat text class="mt-4 px-2">
          <v-row wrap>
            <v-col cols="12" sm="10" md="10" lg="10" class="pb-0">
              <v-text-field
                outlined
                dense
                autocomplete="false"
                name="Alamat Surel Pengguna"
                placeholder="Masukkan alamat surel pengguna yang akan dicari"
                label="Surel"
                v-model="user.email"
                persistent-hint
                @keyup.13.prevent="checkUser"
                data-vv-name="email"
                data-vv-as="Surel"
                :error-messages="errors.collect('form.email')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2">
              <m-button text-button="Cari" icon="mdi-magnify" action="checkUser" @checkUser="checkUser"></m-button>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" v-if="detil && detil.name">
        <m-card title="Detil Pengguna">
          <v-row wrap>
            <v-col cols="12" sm="3" md="4" lg="4" xl="4" class="pr-2 text-center">
              <v-card text color="#fff" flat>
                <v-container fill-height container--fluid>
                  <v-row fill-height>
                    <v-col class="text-center" cols="12" align-end colbox>
                      <v-avatar :size="125" color="blue lighten-5">
                        <v-img
                          fluid
                          :src="
                            detil.kelamin == 'L'
                              ? 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-laki.png'
                              : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-perempuan.png'
                          "
                        ></v-img>
                      </v-avatar>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" xl="9">
              <v-list>
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">Nama</v-list-item-subtitle>
                        <div class="black--text body-1">{{ pVal(detil, "name") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">Sekolah</v-list-item-subtitle>
                        <div class="black--text body-1">{{ pVal(detil, "nama_sekolah") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="12" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">Surel</v-list-item-subtitle>
                        <div class="black--text body-1">{{ pVal(detil, "email") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">Komunitas</v-list-item-subtitle>
                        <div class="black--text body-1">{{ pVal(detil, "komunitas") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-col>
          </v-row>
          <span class="title black--text">Daftar Kelas yang diikuti</span>
          <v-divider class="mt-3"></v-divider>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
              <v-data-table hide-default-header :items="detil.enrol_kelas_p3k" :items-per-page="15" item-key="id" :hide-default-footer="true">
                <template v-slot:body="{ items }">
                  <div v-for="item in items" :key="item.index">
                    <v-row class="mx-0 mt-2">
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="my-0 py-1">
                        <span class="caption mb-0 pb-0">Kelas</span>
                        <p class="subtitle-1 primary--text my-0">
                          <strong>{{ pVal(item.kelas, "nama") }}</strong>
                          <m-chip
                            v-if="item.kategori_id == 2"
                            x-small
                            class="mt-n4"
                            :color="statusJadwal(item) == 'Tryout Selesai' ? 'red' : 'orange'"
                            :title="statusJadwal(item)"
                          ></m-chip></p
                      ></v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="my-0 py-1">
                        <span class="caption mb-0 pb-0">Jadwal Pelaksanaan</span>
                        <div v-if="item.kategori_id == 2 && item.waktu">
                          <p class="teal--text my-0">
                            <strong>{{ item.waktu.tanggal | toD }}</strong>
                          </p>
                          <p class="black--text my-0">{{ item.waktu.sesi.waktu_mulai }} s/d {{ item.waktu.sesi.waktu_selesai }} WIB</p>
                        </div>
                        <div v-else-if="item.kategori_id == 2 && !item.waktu">
                          <span>Belum terjadwal tryout</span>
                        </div>
                        <div v-else>
                          <p class="teal--text my-0">
                            <strong>{{ pVal(item, "waktu_mulai") | toDT }} s/d {{ pVal(item, "waktu_selesai") | toDT }} </strong>
                          </p>
                        </div>
                        <span class="black--text">
                          <i>
                            Tautan LMS:
                            <a target="_blank" :href="item.kelas_moodle ? item.kelas_moodle.lms_url : ''">{{
                              item.kelas_moodle ? item.kelas_moodle.lms_url : "Tautan belum tersingkron"
                            }}</a>
                          </i>
                        </span>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="my-0 py-1">
                        <span class="caption mb-0 pb-0">Status</span>
                        <div v-if="item.kategori_id == 2">
                          <m-chip color="primary" :title="item.nilai ? 'Nilai: ' + item.nilai : 'Nilai tidak tersedia'"></m-chip>
                        </div>
                        <div v-else>
                          <m-chip :color="item.is_complete ? 'success' : 'error'" :title="item.is_complete ? 'Tuntas' : 'Tidak Tuntas'"></m-chip>
                        </div>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </m-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      user: {
        email: null,
        username: null,
        kode_aktivasi: null
      },
      defUser: {
        name: null,
        email: null,
        username: null,
        kode_aktivasi: null,
        enrol_kelas_p3k: []
      },
      detil: null,
      headers: [
        { text: "Nama Kelas", align: "left", value: "", sortable: false },
        { text: "Jadwal Pelaksanaan", align: "left", value: "", sortable: false },
        { text: "Status", align: "left", value: "", sortable: false }
      ]
    };
  },
  mounted() {
    this.detil = this.defUser;
  },
  methods: {
    checkUser() {
      return this.$store
        .dispatch("user/searchPPPK", this.user.email)
        .then(res => {
          if (res.id) {
            this.detil = { ...res };
          } else {
            this.$error("Akun tidak ditemukan");
            this.detil = null;
          }
        })
        .catch(e => e);
    },
    statusJadwal(item) {
      if (item.waktu) {
        var waktuMulai = this.$tools.combineWaktu(item.waktu.tanggal, item.waktu.sesi.waktu_mulai);
        var waktuSelesai = this.$tools.combineWaktu(item.waktu.tanggal, item.waktu.sesi.waktu_selesai);
        if (this.$tools.parseIsAfter(item.server_time, waktuSelesai)) {
          return "Tryout Selesai";
        } else if (this.$tools.parseIsBefore(item.server_time, waktuMulai)) {
          return "Belum dibuka";
        } else if (this.$tools.parseIsAfter(item.server_time, waktuMulai) && this.$tools.parseIsBefore(item.server_time, waktuSelesai)) {
          return "Sedang Berlangsung";
        } else {
          return "Persiapan Tryout";
        }
      } else {
        return "Sedang dijadwalkan";
      }
    }
  }
};
</script>
